import React from "react";
import Skeleton from "react-loading-skeleton";

interface RefundDetailsSkeletonProps {
  width?: string;
}

const RefundDetailsSkeleton: React.FC<RefundDetailsSkeletonProps> = ({
  width = "w-1/4",
}) => {
  return (
    <div className={`flex flex-col gap-[12px] mt-[20px] mr-[16px] ${width}`}>
      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        {/* Trade Header */}
        <div className="flex flex-row justify-between">
          <Skeleton height={20} width={100} />
          <Skeleton height={20} width={50} />
        </div>

        {/* MID | MUID Section */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">MID | MUID</span>
          <Skeleton height={10} width={100} />
        </div>

        {/* MOID */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">MOID</span>
          <Skeleton height={10} width={100} />
        </div>

        {/* UTR Number */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Cx UTR Number</span>
          <Skeleton height={10} width={100} />
        </div>

        {/* Merchant Name */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Merchant Name</span>
          <Skeleton height={10} width={100} />
        </div>

        {/* Cashier Name */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Cashier Name</span>
          <Skeleton height={10} width={100} />
        </div>

        {/* UPI */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Cashier/User UPI</span>
          <Skeleton height={10} width={120} />
        </div>

        {/* Trade Date */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Trade Date & Time</span>
          <Skeleton height={10} width={150} />
        </div>

        {/* Refund Date */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Refund Date & Time</span>
          <Skeleton height={10} width={150} />
        </div>
      </div>

      <div className="flex flex-col py-[8px] px-[12px] space-y-[12px] border border-border-subtle bg-bg-base rounded-lg">
        {/* Refund Agent */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Refund Agent</span>
          <Skeleton height={10} width={100} />
        </div>

        {/* Screenshot from cx */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Screenshot from cx</span>
          <Skeleton circle height={16} width={16} />
        </div>

        {/* Trade Amount */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Trade Amount</span>
          <Skeleton height={10} width={100} />
        </div>

        {/* Refund Amount */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Refund Amount</span>
          <Skeleton height={10} width={100} />
        </div>

        {/* Refund Screenshot */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Refund Screenshot</span>
          <Skeleton circle height={16} width={16} />
        </div>

        {/* Status */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Status</span>
          <Skeleton height={10} width={80} />
        </div>

        {/* Cashier Notes */}
        <div className="flex flex-row justify-between items-center">
          <span className="text-[12px]">Cashier Notes</span>
          <Skeleton height={10} width={120} />
        </div>

        {/* Action Buttons */}
        <div className="flex flex-row justify-between items-center">
          <Skeleton height={32} width={100} />
          <Skeleton height={32} width={100} />
        </div>
      </div>
    </div>
  );
};

export default RefundDetailsSkeleton;
